import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { useTickets } from 'contexts/TicketsContext';
import { ModalSizeE } from 'declarations/enums/modal';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import { DangerousIcon } from 'icons';

import { getPopupContentStyle } from './CloseTicketPopup.styled';
import useCloseTicketPopup from './hooks/useCloseTicketPopup';

const CloseTicketPopup: FC = () => {
  /**
   * Hooks
   */
  const { selectedTicketsIds } = useTickets();

  const {
    isCloseTicketPopupOpened,
    handleClosePopup,
    handleCloseTicket,
    isClosingTicket,
    isSelectedTicketCountEmpty,
  } = useCloseTicketPopup();
  const { isMobile } = useResponsive();

  return (
    <Popup
      nested
      showCloseBtn
      modalTitle="Close Ticket"
      size={ModalSizeE.CLOSE_TICKET}
      contentStyle={getPopupContentStyle(isMobile)}
      popupId={ScrollLockIdE.TicketClosePopup}
      isOpen={isCloseTicketPopupOpened}
      onClose={handleClosePopup}
      closeOnEscape={false}
    >
      {!isSelectedTicketCountEmpty && (
        <>
          <Typography align="center">
            Are you sure you want to close {selectedTicketsIds.length} tickets?
          </Typography>
          <Box display="flex" justifyContent="flex-end" pt={4}>
            <Button
              variant="contained"
              disabled={isClosingTicket}
              onClick={handleCloseTicket(selectedTicketsIds, false)}
            >
              {isClosingTicket ? 'Closing...' : 'Yes'}
            </Button>
          </Box>
        </>
      )}

      {isSelectedTicketCountEmpty && (
        <Box display="flex" flexDirection="column" alignItems="center">
          <DangerousIcon size="13xl" color="red" />
          <Typography py={4}>Please select at least one ticket</Typography>
        </Box>
      )}
    </Popup>
  );
};

export default CloseTicketPopup;
